import { render, staticRenderFns } from "./singleWork.vue?vue&type=template&id=49b43d2c&scoped=true&"
import script from "./singleWork.vue?vue&type=script&lang=js&"
export * from "./singleWork.vue?vue&type=script&lang=js&"
import style0 from "./singleWork.vue?vue&type=style&index=0&id=49b43d2c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b43d2c",
  null
  
)

export default component.exports